import React, { Component } from 'react';

class SiteCredit extends Component {
  constructor(props) {
    super(props);

    this.step = this.step.bind(this);

    this.state = {
      delay: 500,
      activeIndex: 0,
      urls: ['andnate.co', 'andjohanna.co']
    };
  }

  componentDidMount() {
    this.timeout = setTimeout(this.step, this.state.delay);
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  step() {
    this.timeout = setTimeout(this.step, this.state.delay);

    this.setState({
      activeIndex: this.state.activeIndex == 0 ? 1 : 0
    });
  }

  render() {
    const { activeIndex, urls } = this.state;

    return (
      <span><a href={`http://${urls[activeIndex]}`} target="_blank" rel="nofollow noreferrer">{urls[activeIndex]}</a></span>
    );
  }
}

export default SiteCredit;



// WEBPACK FOOTER //
// ./src/components/SiteCredit/index.js